import React from 'react';
import createClasses from './styles';

interface EdgeStatusBadgeProps {
  status: string;
}

const EdgeStatusBadge = ({ status }: EdgeStatusBadgeProps) => {
  const classes = createClasses();
  const isOnline = status?.toLowerCase() === 'online';
  const dotClass = isOnline ? classes.online : classes.offline;

  return (
    <span className={classes.badge}>
      <span className={`${classes.dot} ${dotClass}`} />
      {status || 'N/A'}
    </span>
  );
};

export default EdgeStatusBadge;
